import { MovementMap } from "../../MovementMap";
import { MovementTabs } from "../../MovementTabs";
import { StopEntry } from "../../StopEntry";
import { StopNotesAndReferenceNumbers } from "../../StopNotesAndReferenceNumbers";
import { StopProgress } from "../../StopProgress";
import { DispatchEquipAlerts } from "../DispatchEquipAlerts";
import { DispatchNext } from "../DispatchNext";
import { DispatchPrev } from "../DispatchPrev";
import { DriverCallins } from "../DriverCallins";
import { EmptyTable } from "../EmptyTable";
import { EquipmentGroupWarnings } from "../EquipmentGroupWarnings";
import { TrackingHistory } from "../TrackingHistory";
import { TrailerContinuityWarnings } from "../TrailerContinuityWarnings";
import { Button, Checkbox, CityState, DataSource, Image, Label, Layout, Panel, Splitter, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDispatch extends Layout {
    buttonLocate: Button;
    checkboxFaultOfCarrierOrDriver: Checkbox;
    checkboxIsReportable: Checkbox;
    checkboxTrailer2Dropped: Checkbox;
    checkboxTrailer3Dropped: Checkbox;
    checkboxTrailerDropped: Checkbox;
    citystateNextStop: CityState;
    citystateUnclearedStop: CityState;
    imageApptConfirmed: Image;
    imageEmptyOrder: Image;
    imageDetention: Image;
    imageIncident: Image;
    imageLoaded: Image;
    imageNextApptConfirmed: Image;
    imageNextStop: Image;
    imageTrailerWarning: Image;
    labelAddress2: Label;
    labelAddress: Label;
    labelApptStatus: Label;
    labelCityName: Label;
    labelClearStopTitle: Label;
    labelDolly2Id: Label;
    labelETA: Label;
    labelEmptyOrder: Label;
    labelEmptyTo: Label;
    labelLastHome2: Label;
    labelLastHome: Label;
    labelLastHomeDate2: Label;
    labelLastHomeDate: Label;
    labelLocateHelper: Label;
    labelLocationAddress2: Label;
    labelLocationAddress: Label;
    labelLocationCaption: Label;
    labelLocationName: Label;
    labelNextAddress2: Label;
    labelNextAddress: Label;
    labelNextApptStatus: Label;
    labelNextHome2: Label;
    labelNextHome: Label;
    labelNextHomeDate2: Label;
    labelNextHomeDate: Label;
    labelNextLocationName: Label;
    labelNextStopDistanceCaption: Label;
    labelNextStopTitle: Label;
    labelNexttopDetails: Label;
    labelOrder: Label;
    labelOrderId: Label;
    labelServiceIncidentTitle: Label;
    labelState: Label;
    labelStopDetails: Label;
    labelStopsPickDrop: Label;
    labelTitle: Label;
    labelTrackingLateBadge: Label;
    labelTrailer2Id: Label;
    labelTrailer3Id: Label;
    labelTrailerWarning: Label;
    labelTrailerWarnings: Label;
    labelZipcode: Label;
    layoutDispatchEquipAlerts: DispatchEquipAlerts;
    layoutDispatchNext: DispatchNext;
    layoutDispatchPrev: DispatchPrev;
    layoutDriverCallins: DriverCallins;
    layoutEmptyTabs: MovementTabs;
    layoutEquipmentGroupWarnings: EquipmentGroupWarnings;
    layoutMovementMap: MovementMap;
    layoutMovementTabs: MovementTabs;
    layoutNextEmpty: EmptyTable;
    layoutPrevEmpty: EmptyTable;
    layoutStopEntry: StopEntry;
    layoutStopNotesAndRefNumber: StopNotesAndReferenceNumbers;
    layoutStopProgress: StopProgress;
    layoutTrackingHistory: TrackingHistory;
    layoutTrailerContinuityWarnings: TrailerContinuityWarnings;
    panelAction: Panel;
    panelAppointment: Panel;
    panelApptStatus: Panel;
    panelCityStateZip: Panel;
    panelClearStop: Panel;
    panelDetention: Panel;
    panelDispatchSection: Panel;
    panelDollyInfo: Panel;
    panelDriver2Info: Panel;
    panelDriver2PTA: Panel;
    panelDriverInfo: Panel;
    panelDriverPTA: Panel;
    panelDropTrailer: Panel;
    panelETA: Panel;
    panelEmptyOrder: Panel;
    panelEmptySection: Panel;
    panelHomes2: Panel;
    panelHomes: Panel;
    panelIncidentIcon: Panel;
    panelIncidentInfo: Panel;
    panelLocate: Panel;
    panelLocateLocation: Panel;
    panelLocateStops: Panel;
    panelMainContent: Panel;
    panelMaxTrailers2: Panel;
    panelMaxTrailers3: Panel;
    panelNextAppointment: Panel;
    panelNextApptStatus: Panel;
    panelNextStop: Panel;
    panelNextStopDetails: Panel;
    panelNextStopDistance: Panel;
    panelNextStopInfo: Panel;
    panelOrderInfo: Panel;
    panelOrderNumber: Panel;
    panelOtherInfo: Panel;
    panelOverview: Panel;
    panelServiceIncident: Panel;
    panelStopDetails: Panel;
    panelTractorInfo: Panel;
    panelTrailerInfo: Panel;
    panelTrailerWarnings: Panel;
    panelUnclearedStopInfo: Panel;
    panelWarningTexts: Panel;
    sourceDispatchAsset: DataSource;
    sourceDispatchMovements: DataSource;
    sourceMovement: DataSource;
    sourcePreassignments: DataSource;
    sourceServicefail: DataSource;
    sourceStop: DataSource;
    splitterTracking: Splitter;
    switchDispatchAction: Switch;
    switchDropTrailer: Switch;
    tabCurrent: Tab;
    tabDispatch: Tab;
    tabEquipmentAlerts: Tab;
    tabNext: Tab;
    tabNextEmpty: Tab;
    tabPrev: Tab;
    tabPrevEmpty: Tab;
    tabTracking: Tab;
    tabsetDispatch: Tabset;
    tabsetDispatchLayouts: Tabset;
    textboxActualArrival: Textbox;
    textboxActualDeparture: Textbox;
    textboxCases: Textbox;
    textboxCausedByType: Textbox;
    textboxCurrentLocation: Textbox;
    textboxDistanceNextStop: Textbox;
    textboxDolly2Id: Textbox;
    textboxDolly: Textbox;
    textboxDollyId: Textbox;
    textboxDriver2Id: Textbox;
    textboxDriver2Pta: Textbox;
    textboxDriverId: Textbox;
    textboxDriverLoadUnload: Textbox;
    textboxDriverPTA: Textbox;
    textboxDspComment: Textbox;
    textboxE: Textbox;
    textboxEdiStandardCode: Textbox;
    textboxEmptyTrailer: Textbox;
    textboxLocateActualArrival: Textbox;
    textboxLocationName: Textbox;
    textboxMoveDistFromPreviousUm: Textbox;
    textboxNextSchedArriveEarly: Textbox;
    textboxSchedArriveEarly: Textbox;
    textboxSchedArriveLate: Textbox;
    textboxStopType: Textbox;
    textboxStopWeight: Textbox;
    textboxTractorId: Textbox;
    textboxTrailer2Id: Textbox;
    textboxTrailer3Id: Textbox;
    textboxTrailer: Textbox;
    textboxTrailerId: Textbox;
    textboxTrailerOut: Textbox;
}
